import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

import { Prompt } from '../../models/loan-application.model';

export interface SupplementalSectionPromptsState extends EntityState<Prompt, string> {
  promptCode: string;
}

function createInitialState(): Prompt {
  return <Prompt>{};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'supplemental-section-prompts-store', idKey: 'promptCode' })
export class SupplementalSectionPromptsStore extends EntityStore<SupplementalSectionPromptsState> {
  constructor() {
    super(createInitialState());
  }
}
